/**
 * STALE-DEPLOY-RECOVERY-1 (2026-05-29) — extracted predicate
 *
 * Shared between:
 *   - main.jsx window-level error/unhandledrejection handlers (STALE-CHUNK-RECOVERY-1)
 *   - lib/lazyWithRetry.js — promise-level interceptor that fires before React's
 *     ErrorBoundary catches the rejection
 *
 * The classic failure mode: a deploy lands while customers have the app open,
 * their cached index.html references chunk filenames that no longer exist on
 * the CDN, Netlify's SPA fallback returns index.html (text/html MIME) for the
 * missing /assets/Foo-OLDHASH.js path, and the browser refuses the MIME
 * mismatch with one of several distinct error messages depending on the
 * browser engine + the rejection path.
 *
 * @param {string|Error|{message?: string}|unknown} messageOrReason
 * @returns {boolean}
 */
export function isStaleChunkError(messageOrReason) {
  const m = String(
    (messageOrReason && typeof messageOrReason === 'object' && 'message' in messageOrReason
      ? /** @type {{message?: string}} */ (messageOrReason).message
      : messageOrReason) ?? ''
  );
  return (
    m.includes('Failed to fetch dynamically imported module') ||
    m.includes('Importing a module script failed') ||
    m.includes('error loading dynamically imported module') ||
    /Loading chunk \S+ failed/i.test(m) ||
    /ChunkLoadError/i.test(m) ||
    /Expected a JavaScript-or-Wasm module script but the server responded with a MIME type of "text\/html"/i.test(m)
  );
}
